export const actions = {
    SET_FEATURE_FLAGS: 'SET_FEATURE_FLAGS',
};

export const setFeatureFlags = payload => ({
    type: actions.SET_FEATURE_FLAGS,
    payload,
});
